import handler from '../handler/handler'
import messages from '../handler/messages/wine-messages'

const statusHandler = handler(messages)

export default {
  state: {
    wines: [],
    details: [],
  },
  getters: {
    getWineList: state => state.wines,
    getDetailList: state => state.details,
  },
  mutations: {
    successWines: (state, payload) => {
      state.wines = payload
    },
    successDetails: (state, payload) => {
      state.details = payload
    },
  },
  actions: {
    getWineList: async ({
      commit,
      getters,
    }) => {
      const result = await statusHandler.authGet({
        commit,
        getters,
      }, '/api/wines/')

      commit('successWines', result.response.result.rows)
      return result.response.result.rows
    },

    isCheckWineToInventory: async ({
      commit,
      getters,
    }, {
      id,
    }) => {
      const result = await statusHandler.authGet({
        commit,
        getters,
      }, `/api/wines/${id}/check_inventory`)
      return result.response
    },

    getDetailList: async ({
      commit,
      getters,
    }) => {
      const result = await statusHandler.authGet({
        commit,
        getters,
      }, '/api/details/')

      commit('successDetails', result.response.result.rows)
      return result.response.result.rows
    },

    updateWine: async ({
      commit,
      getters
    }, data) => {
      const wine = {
        id: data.id,
        type: data.type,
        wine_name: data.wineName,
        wine_name_en: data.wineNameEn,
        short_wine_name: data.shortWineName,
        vintage_year: data.vintageYear,
        region_id: data.regionId,
        winery_id: data.wineryId,
        supplier_id: data.supplierId,
        wine_dsc_short: data.wineDscShort,
        img_bottle: data.imgBottle,
        winepoint: data.winepoint,
        price: data.price,
        is_checked: data.isChecked,
      }

      const result = await statusHandler.authPut({
        commit,
        getters
      }, `/api/wines/${wine.id}`, wine)
      return result
    },

    updateDetail: async ({
      commit,
      getters
    }, data) => {
      const details = {
        wine_id: data.wineId,
        grapes: data.grapes,
        aromas: data.aromas,
        volume: data.volume,
        abv: data.abv,
        detail_imgs: data.detailImgs,
        img_label: data.imgLabel,
        wine_dsc: data.wineDsc,
        body: data.body,
        acidity: data.acidity,
        tannin: data.tannin,
        sweetness: data.sweetness,
      }

      const result = await statusHandler.authPut({
        commit,
        getters
      }, `/api/details/${details.wine_id}`, details)
      return result
    },

    createEmptyWine: async ({
      commit,
      getters
    }) => {
      const result = await statusHandler.authPost({
        commit,
        getters
      }, '/api/wines/')

      return result
    },

    deleteWine: async ({
      commit,
      getters
    }, id) => {
      const result = await statusHandler.authDelete({
        commit,
        getters
      }, `/api/wines/${id}`)
      return result
    },

    deleteWines: async ({
      commit,
      getters
    }, ids) => {
      const result = await statusHandler.authPatch({
        commit,
        getters
      }, '/api/wines/delete', ids)
      return result
    },
  },
}



// WEBPACK FOOTER //
// ./src/vuex/modules/wine.js